import axios from 'axios';
import { baseUrl, withAuth } from '../auth/helper';

export default {
  getWallet: withAuth(async (params, options) => {
    const response = await axios.get(`${baseUrl}/wallet`, options)
    return response
  }),
}